// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__VFpXG","title":"ClientInsurance_title__3-c36","itemText":"ClientInsurance_itemText__1xhVb"};